import options from './thing-signal.component';

export default {
    selector: 'dtAsThingSignal',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-signal/index.js